var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('div',{staticClass:"display-1 text--primary"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }